<template>
  <div>
    <Question
      :question="question"
      :index="index"
    />
    <VTextField
      v-model="answer"
      class="input"
      required
      outlined
      dense
      type="number"
      :disabled="disabledAnswers"
      :placeholder="$t('enterTheAnswer')"
      :error-messages="answerErrors"
      @input="answerQuestion()"
    />
  </div>
</template>

<script>
import {
  toRefs, computed, ref, onMounted,
} from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import Question from './Question.vue';

export default {
  name: 'TextQuestion',
  components: {
    Question,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabledAnswers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { question, answers } = toRefs(props);
    const { t } = useI18n();

    const answer = ref('');
    const showValidationMessages = ref(false);

    const isEmptyAnswer = computed(() => !answer.value || !answer.value.trim());

    const isValid = computed(() => !(isEmptyAnswer.value));

    function answerQuestion() {
      if (!showValidationMessages.value) {
        showValidationMessages.value = true;
      }
      const a = {
        questionId: question.value.id,
        answer: answer.value,
        isValid: isValid.value,
      };
      emit('answer', a);
    }

    function setAnswer() {
      const a = {
        questionId: question.value.id,
        answer: answer.value,
        isValid: isValid.value,
      };
      emit('setAnswer', a);
    }

    function getAnswer() {
      if (!answers.value.length) {
        return;
      }
      const a = answers.value.filter(a => a.testQuestionId === question.value.id);
      if (a.length) {
        answer.value = a[0].answer;
        setAnswer();
      }
    }

    const answerErrors = computed(() => {
      const errors = [];

      if (isEmptyAnswer.value && showValidationMessages.value) {
        errors.push(t('requiredField'));
      }

      return errors;
    });

    onMounted(() => {
      getAnswer();
    });

    return {
      answerQuestion,
      answer,
      answerErrors,
    };
  },
};
</script>

<style lang="scss" scoped>
.input {
  max-width: 50%;
}
</style>

<i18n locale="en" lang="yaml">
  enterTheAnswer: Enter your answer
  requiredField: This field is required
</i18n>

<i18n locale="ru" lang="yaml">
  enterTheAnswer: Введите ответ
  requiredField: Обязательное поле для заполнения
</i18n>
